// Renders a darkred text in a lightred box

import { JSX } from "react";

type Props = {
    errorMessage: string
    style?: any
}

const ErrorMessageBox = (props: Props) => {
    return (
        <span className="error-box" style={props.style}>
            {props.errorMessage}
        </span>
    )
};

export const ErrorMessageBoxJSX = ({ children }: { children: JSX.Element }) => (
    <div className="error-box-big">
        {children}
    </div>
)

export default ErrorMessageBox;